import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tournaments-sidebar" }

import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import TournamentDTO from "@/models/TournamentDTO";
import {TournamentStatus} from "@/models/enum/TournamentStatus";
import TournamentContent from "@/components/TournamentContent.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import {$t} from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'TournamentSidebar',
  setup(__props) {

const store = useStore()
const router = useRouter()

const sliderRef = ref<InstanceType<typeof HTMLElement> | null>(null)
const activeIndex = ref(0)

const selectedTournament = computed(() => {
  return store.getters.liveTournaments[activeIndex.value]
})

const activeTournaments = computed(() => {
  return store.getters.liveTournaments.filter((item: TournamentDTO) => item.status === TournamentStatus.ACTIVE)
})


onMounted(() => {
  activeIndex.value = 0
  sliderRef.value?.addEventListener('scroll', () => {
    const el = sliderRef.value!
    const itemWidth = el.firstElementChild!.clientWidth + 16
    activeIndex.value = Math.round(el.scrollLeft / itemWidth)
  }, { passive: true })
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push({name: 'home'})), ["prevent"])),
      class: "nav-back"
    }, [
      _createVNode(SvgIcon, { icon: "back" }),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("span", null, _toDisplayString(_unref($t)('back_to_lobby')), 1)
    ]),
    _createElementVNode("div", {
      class: "header-slider",
      ref: (el) => sliderRef.value = el
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeTournaments.value, (item, index) => {
        return (_openBlock(), _createBlock(TournamentCard, {
          item: item,
          key: item.id,
          class: "header-slider__item"
        }, null, 8, ["item"]))
      }), 128))
    ], 512),
    _createVNode(TournamentContent, {
      class: "sidebar",
      tournament: selectedTournament.value
    }, null, 8, ["tournament"])
  ]))
}
}

})